import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=1cfde32a"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsLanguageSwitcher: require('/app/components/Commons/LanguageSwitcher.vue').default,CommonsCopyButton: require('/app/components/Commons/CopyButton.vue').default,CommonsThemeMode: require('/app/components/Commons/ThemeMode.vue').default})
